module.exports = __webpack_public_path__ + "img/American_Credit_Use_Your_Fund_as_You_Choose_D.afc952b.png";